import { Injectable } from '@angular/core';
import { FieldConfig } from '../models/field.interface';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';

export enum ValidationType {
  isRequired,
  onChange,
  onBegin,
  onEnd
}
@Injectable()
export class ValidationService {
  private behaviourSource = new BehaviorSubject({});
  behaviourData = this.behaviourSource.asObservable();

  constructor() { }
  // delete dynamic fields
  checkValue(value) {
    var undefinedVal = true;
    for (var i = value.length - 1; i >= 0; i--) {
      if (value[i] !== '') {
        undefinedVal = false;
        return false;
      }
    }
    if (undefinedVal) {
      return true;
    }
  }
  applyValidation(field: FieldConfig, dataObj, type: Array<ValidationType>) {

    if (field && field.section && field.section.fields && field.section.page && field.section.page.sections) {
      _.forEach(field.section.page.sections, (section) => {
        _.forEach(section.fields, (field) => {
          dataObj[field.id] = field.value;
        })
      });
    }
    if (type.includes(ValidationType.isRequired)) {
      if (field.validation.isRequired && (!field.value || field.value === '' || (field.dynamic && this.checkValue(field.value)))) {
        field.errorMessage = 'Field Required';
      } else {
        field.errorMessage = '';
      }
    }
    if (type.includes(ValidationType.onChange), field.validation.onChange) {

      const jsFunction = field.validation.onChange['function'];
      const data = JSON.stringify({ data: dataObj });

      var evalRes;
      if (field.section.page.customData) {
        const customStringData = JSON.stringify(field.section.page.customData);
        evalRes = Function('"use strict";return(' + jsFunction + ')')()(data, customStringData);
      } else {
        evalRes = Function('"use strict";return(' + jsFunction + ')')()(data);
      }

      if (evalRes && evalRes.behaviour && (evalRes.behaviour.data || evalRes.behaviour.options || evalRes.behaviour.visibility || evalRes.behaviour.editability || evalRes.behaviour.background_color || evalRes.behaviour.border_color || evalRes.behaviour.border_thickness || evalRes.behaviour.corner_radius)) {

        this.behaviourSource.next(evalRes.behaviour);
      } else if (evalRes && evalRes.behaviour && typeof evalRes.behaviour == "string") {

        this.behaviourSource.next(field.behaviour[evalRes.behaviour]);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/rFF/services/validation.service.ts